// frontend/src/Router.jsx
import { Routes, Route, Navigate } from 'react-router-dom';

// Pages
import Home from '../pages/Home';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import VerifyEmail from '../pages/auth/VerifyEmail';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import ProfileSetup from '../pages/auth/ProfileSetup';
import ChangePassword from '../pages/auth/ChangePassword';
import AboutUs from '../pages/AboutUs'
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfServices';
import ContactUs from '../pages/ContactUs';
import CookiePolicy from '../pages/cookie-policy';

// Applier
import JobSearch from '../pages/applier/JobSearch';
import ApplierDashboard from '../pages/applier/ApplierDashboard';
import JobDetails from '../pages/applier/JobDetails';
import MyApplications from '../pages/applier/MyApplications';
import ApplierProfileView from '../pages/applier/ApplierProfileView';
import ApplierProfileForm from '../pages/applier/ApplierProfileForm'; // ✅ new

// Recruiter
import RecruiterDashboard from '../pages/recruiter/RecruiterDashboard';
import PostJobForm from '../pages/recruiter/CreateJob';
import RecruiterApplicants from '../pages/recruiter/Applicants';
// import CreateJobForm from '../components/forms/JobForm';
import ApplicantReview from '../components/forms/ApplicantReview';
import RecruiterProfileEdit from '../pages/recruiter/RecruiterProfileEdit';
import EditJobForm from '../pages/recruiter/EditJobForm';
import RecruiterJobsOverview from '../pages/recruiter/RecruiterJobsOverview'
import RecruiterJobDetails from '../pages/recruiter/RecruiterJobDetails';
import RecruiterApplicationsAnalytics from '../pages/recruiter/RecruiterApplicationAnalytics';
import RecruiterApplications from '../pages/recruiter/RecruiterApplications';
import ApprovedJobsPage from '../pages/recruiter/ApprovedJobsPage';
import AcceptedApplications from '../pages/recruiter/AcceptedApplications';

// Admin
import AdminDashboard from '../pages/admin/AdminDashboard';
import ManageUsers from '../pages/admin/ManageUsers';
import UserAnalytics from '../pages/admin/UserAnalytics';
import RecruiterAnalytics from '../pages/admin/RecruiterAnalytics';
import ApprovedJobs from "../pages/admin/ApprovedJobs"
import RecruiterProfilePage from '../pages/recruiter/RecruiterProfile';
import PendingJobsPage from '../pages/recruiter/PendingJobsPage';
import CreateAdmin from '../pages/admin/CreateAdmin';
import CreateBlog from '../pages/admin/CreateBlog'; // NEW: Admin create blog
import BlogList from '../pages/blog/BlogList'; // NEW: Public blog list
import BlogDetails from '../pages/blog/BlogDetails'; // NEW: Public blog details
import AdminBlogAnalytics from '../pages/admin/AdminBlogAnalytics';
import AdminBlogDetailStats from '../pages/admin/AdminBlogDetailStats';
import EditBlog from '../pages/admin/EditBlog';

// Auth
import ProtectedRoute from './ProtectedRoute';
import ApplicationsPage from '../pages/admin/ApplicationsPage';
import AdminPostJob from '../pages/admin/AdminPostJob';
import AdminJobDetails from '../pages/admin/AdminJobDetails';
import AdminProfile from '../pages/admin/AdminProfile';
import AdminProfileEdit from '../pages/admin/AdminProfileEdit';
import TelegramWelcome from '../pages/auth/TelegramWelcome';

const Router = () => {
  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route path="/telegram-welcome" element={<TelegramWelcome />} />
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<BlogList />} /> {/* NEW: Public Blog Routes */}
      <Route path="/blog/:id" element={<BlogDetails />} /> {/* NEW */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify/:token" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/profile/setup" element={<ProfileSetup />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      {/* JOB SEARCH & DETAILS (AUTHENTICATED USERS) */}
      <Route element={<ProtectedRoute />}>
        <Route path="/jobs" element={<JobSearch />} />
        <Route path="/jobs/:jobId" element={<JobDetails />} />
      </Route>
     
      {/* APPLIER ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={['APPLIER']} />}>
        <Route path="/applier/dashboard" element={<ApplierDashboard />} />
        <Route path="/applier/applications" element={<MyApplications />} />
        <Route path="/profile" element={<ApplierProfileView />} />
        <Route path="/applier/profile-form" element={<ApplierProfileForm />} /> {/* ✅ new */}

      </Route>

      {/* RECRUITER ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={['RECRUITER']} />}>
        <Route path="/recruiter/dashboard" element={<RecruiterDashboard />} />
        <Route path="/recruiter/post-job" element={<PostJobForm />} />
        <Route path="/recruiter/jobs/:jobId/applicants" element={<RecruiterApplicants />} />
        
        <Route path="/recruiter/profile/edit" element={<RecruiterProfileEdit />} />
        <Route path="/recruiter/profile" element={<RecruiterProfilePage />} />
        <Route path="/recruiter/applications/:appId" element={<ApplicantReview />} />
        <Route path="/recruiter/jobs/:jobId/edit" element={<EditJobForm />} />
        <Route path="/recruiter/my-jobs" element={<RecruiterJobsOverview/>} />
        <Route path="/recruiter/jobs/:jobId" element={<RecruiterJobDetails />} />
        <Route
          path="/recruiter/applications/analytics"
          element={<RecruiterApplicationsAnalytics />}
        />
        <Route path="/recruiter/applications/accepted" element={<AcceptedApplications />} />
        <Route path="/recruiter/applications" element={<RecruiterApplications />} />
        <Route path="/recruiter/jobs/pending" element={<PendingJobsPage />} />
        <Route path="/recruiter/jobs/approved" element={<ApprovedJobsPage />} />

      </Route>

      {/* ADMIN ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/jobs/new" element={<AdminPostJob />} />
        <Route path="/admin/jobs/:jobId" element={<AdminJobDetails />} />
        <Route path="/admin/users" element={<ManageUsers />} />
        <Route path="/admin/user-analytics" element={<UserAnalytics />} /> {/* NEW */}
        <Route path="/admin/recruiter-analytics" element={<RecruiterAnalytics />} /> {/* NEW */}
        <Route path="/admin/jobs/approved" element={<ApprovedJobs />} />
        <Route path="/admin/applications" element={<ApplicationsPage />} />
        <Route path="/admin/applications/:appId" element={<ApplicantReview />} />
        <Route path="/admin/create-admin" element={<CreateAdmin />} />
        <Route path="/admin/blog/new" element={<CreateBlog />} /> {/* NEW: Admin Blog Creation */}
        <Route path="/admin/blog-analytics" element={<AdminBlogAnalytics />} />
        <Route path="/admin/blog-analytics/:id" element={<AdminBlogDetailStats />} />
        <Route path="/admin/blog/edit/:id" element={<EditBlog />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/admin/profile/edit" element={<AdminProfileEdit />} />


      </Route>

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Router;